import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend
} from "recharts";
import { Paper, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


const BudgetOverrunChart = ({ projects }) => {
  if (!projects || projects.length === 0) {
    return (
      <Paper
        elevation={3}
        sx={{
          p: 2,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography align="center">
          <ErrorOutlineIcon sx={{ mr: 1, verticalAlign: "middle" }} />
          Aucun dépassement budgétaire trouvé.
        </Typography>
      </Paper>
    );
  }
  const formattedData = projects.map((project) => ({
    name: project.project_code || project.name,
    estimated_budget: project.estimated_budget,
    committed_budget: project.committed_budget,
  }));

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2, height: "100%" }}>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={formattedData}
          layout="vertical"
          margin={{ top: 20, right: 100, left: 40, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={120} />
          <Tooltip formatter={(value) => `${value.toLocaleString()} MAD`} />
          <Legend />
          <Bar dataKey="estimated_budget" fill="#90caf9" name="Budget Prévu" />
          <Bar dataKey="committed_budget" fill="#ef5350" name="Budget Engagé" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default BudgetOverrunChart;
